
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/region/crematorium",
      function () {
        return require("private-next-pages/region/crematorium/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/region/crematorium"])
      });
    }
  